import {
  BASE_URL,
  CHANGE_Language,
  COMPANY,
  COMPANY_EMPLOYEES,
  COMPANY_SETTINGS,
  Languages,
  PROFILE,
  SAVE_PROFILE,
} from "constants/api";
import axios from "../helpers/axiosInstance";
import { HeadCell } from "models/app";
import { ICompany, ICompanyEmployees, ICompanyInput, ICompanyVendorInput, ICompanyVendors, IProfile } from "models/company";

export async function getCompanies(params: string = ""): Promise<ICompany[]> {
  const response = await axios.get(BASE_URL + COMPANY + params);
  return response.data;
}

export async function getCompanyById(id: string): Promise<ICompany> {
  const response = await axios.get(BASE_URL + COMPANY + "/" + id);
  return response.data;
}

export async function getCompanyEmployees(params: string = ""): Promise<ICompanyEmployees[]> {
  const response = await axios.get(BASE_URL + COMPANY_EMPLOYEES + params);
  return response.data;
}

export async function getCompanyVendors(params: string = ""): Promise<ICompanyVendors[]> {
  const response = await axios.get(BASE_URL + COMPANY + '/getvendors');
  return response.data;
}

export async function getCompanyTimeZone(): Promise<string[]> {
  const response = await axios.get(BASE_URL + COMPANY + '/GetCompanyTimeZone');
  return response.data;
}

export async function getCompanySettings(params: string = "") {
  const response = await axios.get(BASE_URL + COMPANY_SETTINGS + params);
  return response.data;
}

export async function getProfile(params: string = ""): Promise<IProfile> {
  const response = await axios.get(BASE_URL + PROFILE + params);
  return response.data;
}

export async function getLanguages(params: string = "") {
  const response = await axios.get(BASE_URL + Languages + params);
  return response.data;
}

export async function addCompany(data: FormData) {
  const response = await axios.post(BASE_URL + COMPANY, data);
  return response.data;
}

export async function addCompanyVendor(data: ICompanyVendorInput) {
  const response = await axios.post(BASE_URL + COMPANY + '/addvendor', data);
  return response.data;
}

export async function editCompany(data: FormData, id: string) {
  const response = await axios.patch(BASE_URL + COMPANY + "/" + id, data);
  return response.data;
}

export async function editCompanyVendor(data: ICompanyVendorInput, id: string) {
  const response = await axios.patch(BASE_URL + COMPANY + '/editvendor?id=' + id, data);
  return response.data;
}

export async function editCompanySMS(data: Partial<ICompanyInput>) {
  const response = await axios.post(BASE_URL + COMPANY + "/SetSMS", data);
  return response.data;
}

export async function saveProfile(data: FormData) {
  const response = await axios.patch(BASE_URL + SAVE_PROFILE, data);
  return response.data;
}

export async function changePreferredLanguage(data: string) {
  const response = await axios.put(BASE_URL + CHANGE_Language + data);
  return response.data;
}

export async function editCompanySMTP(data: Partial<ICompanyInput>) {
  const response = await axios.post(BASE_URL + COMPANY + "/SetSMTP", data);
  return response.data;
}

export async function editCompanyColors(data: Partial<ICompanyInput>) {
  const response = await axios.post(
    BASE_URL + COMPANY + "/SetCompanyColors",
    data
  );
  return response.data;
}

export async function deleteCompany(code: string) {
  const response = await axios.delete(BASE_URL + COMPANY + "/" + code);
  return response.data;
}

export async function deleteCompanyVendor(code: string) {
  const response = await axios.delete(BASE_URL + COMPANY + '/RemoveVendor' + "/" + code);
  return response.data;
}

export const CompanyCells: HeadCell[] = [
  {
    id: "logo",
    numeric: false,
    disablePadding: false,
    label: "T_Logo",
  },
  {
    id: "name",
    numeric: false,
    disablePadding: false,
    label: "T_name",
  },
  {
    id: "nameAr",
    numeric: false,
    disablePadding: false,
    label: "T_name_Ar",
  },
  {
    id: "industryName",
    numeric: false,
    disablePadding: false,
    label: "T_industry_name",
  },
  {
    id: "industryNameAr",
    numeric: false,
    disablePadding: false,
    label: "T_industry_name_Ar",
  },
  {
    id: "isCorporate",
    numeric: false,
    disablePadding: false,
    label: "T_is_corporate",
  },
  {
    id: "actions",
    numeric: false,
    disablePadding: false,
    label: "T_action",
  },
];

export const CompanyVendorCells: HeadCell[] = [
  {
    id: "logo",
    numeric: false,
    disablePadding: false,
    label: "T_Logo",
  },
  {
    id: "name",
    numeric: false,
    disablePadding: false,
    label: "T_name",
  },
  {
    id: "nameAr",
    numeric: false,
    disablePadding: false,
    label: "T_name_Ar",
  },
  {
    id: "countryName",
    numeric: false,
    disablePadding: false,
    label: "T_country_name",
  },
  {
    id: "active",
    numeric: false,
    disablePadding: false,
    label: "T_active",
  },
  {
    id: "actions",
    numeric: false,
    disablePadding: false,
    label: "T_action",
  },
];
